import Helper from 'ember-intl/helpers/t';

/**
 * Helper per traduzione con supporto per chiavi vuote
 */
class THelper extends Helper {
  constructor(...args) {
    super(...args);
    this.allowEmpty = true;
  }
}

export { THelper as default };
//# sourceMappingURL=t.js.map
